import { createApiAction, createAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as types from './types';

export const getDeviceList = createApiAction(
  types.DEVICE_LIST_GET,
  (payload) => api.fetchPrivateDevices(payload),
);

export const assignDeviceToTeam = createApiAction(
  types.ASSIGN_DEVICE_TO_TEAM,
  (payload) => api.assignDeviceToTeam(payload),
);

export const unAssignDeviceFromTeam = createApiAction(
  types.UNASSIGN_DEVICE_FROM_TEAM,
  (payload) => api.unAssignDeviceFromTeam(payload),
);

export const updateDeviceSettings = createApiAction(
  types.UPDATE_DEVICE_SETTINGS,
  (payload) => api.updateDeviceSettings(payload),
);

export const cleanup = createAction(types.CLEANUP);
